module.exports = __webpack_public_path__ + "img/img-processing.88bef103.png";